<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>信息查询</el-breadcrumb-item>
      <el-breadcrumb-item>评审进度</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="6" style="width:360px !important;margin-right: 20px;">
          <el-select v-model="queryInfo.MatchID" placeholder="请选择赛项" clearable @change="selectGettrack(queryInfo.MatchID)"
                     style="width:360px !important">
            <el-option v-for="item in matchNameoptions" :key="item.MatchID" :label="item.MatchName" :value="item.MatchID">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3" style="margin-right:60px">
          <el-select v-model="queryInfo.TrackID" placeholder="请选择赛道" clearable @change="selectGroup(queryInfo.TrackID)"
                     style="width:260px !important;">
            <el-option v-for="item in trackNameoptions" :key="item.TrackID" :label="item.TrackName" :value="item.TrackID">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-select v-model="queryInfo.JudgesGroupID" placeholder="请选择分组" clearable>
            <el-option v-for="item in groupOptions" :key="item.JudgesGroupID" :label="item.JudgesGroupName" :value="item.JudgesGroupID">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-select v-model="queryInfo.QueryType" placeholder="请选择查看方式" clearable @change="getViewMode">
            <el-option v-for="item in viewModeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <!-- <el-col :span="4">
          <el-select
            v-model="queryInfo.trackName"
            placeholder="请选择评审类型"
            clearable
          >
            <el-option
              v-for="item in reviewTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              @change="getJudgesList(1)"
            >
            </el-option>
          </el-select>
        </el-col> -->

        <el-col :span="2">
          <el-input placeholder="请输入姓名" v-model="queryInfo.JudgesName" clearable>
          </el-input>
        </el-col>
        <el-col :span="1">
          <el-button icon="el-icon-search" type="primary" @click="
              queryInfo.QueryType !== '2' ? getJudgesList(1) : getProjectList(1)
            ">查看进度</el-button>
        </el-col>
        <el-col :span="1">
          <el-button icon="el-icon-download" type="success" @click="doDown">导出</el-button>
        </el-col>
      </el-row>
      <div>
        <!-- 以评委维度表格列表 -->
        <el-table :data="judgespagedata" style="width: 100%" border stripe size="mini" v-if="queryInfo.QueryType !== '2'">
          <el-table-column type="index" label="#"></el-table-column>
          <el-table-column prop="JudgesName" label="评委姓名">
          </el-table-column>
          <el-table-column prop="Telephone" label="联系方式"> </el-table-column>
          <el-table-column prop="EvaluatedItems" label="已评作品">
          </el-table-column>
          <el-table-column prop="UnEvaluatedItems" label="未评作品">
          </el-table-column>
          <el-table-column prop="Progress" label="评审进度" sortable>
            <template slot-scope="scope">
              <div>
                <el-progress :percentage="
                    Number(
                      scope.row.Progress === null
                        ? 0
                        : scope.row.Progress.replace('%', '')
                    )
                  "></el-progress>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="260">
            <template slot-scope="scope">
              <el-button type="primary" icon="el-icon-view" size="mini" @click="showJudges(scope.row)">评审详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 以作品维度表格列表 -->
        <el-table :data="projectpagedata" style="width: 100%" border stripe size="mini" v-else>
          <el-table-column type="index" label="#"></el-table-column>
          <el-table-column prop="EntriesName" label="作品名称">
          </el-table-column>
          <el-table-column prop="FinalScore" label="作品得分">
          </el-table-column>
          <el-table-column prop="EvaluatedJudges" label="已打分评委">
          </el-table-column>
          <el-table-column prop="UnEvaluatedJudges" label="未打分评委">
          </el-table-column>
          <el-table-column prop="Progress" label="评审进度">
            <template slot-scope="scope">
              <div>
                <el-progress :percentage="
                    Number(
                      scope.row.Progress === null
                        ? 0
                        : scope.row.Progress.replace('%', '')
                    )
                  "></el-progress>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="260">
            <template slot-scope="scope">
              <el-button type="primary" icon="el-icon-view" size="mini" @click="showProject(scope.row)">评审详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pagenum"
                       :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total"
                       background>
        </el-pagination>
      </div>
      <!-- 以评委维度评审详情 -->
      <el-dialog title="评审详情" :visible.sync="judgesDialogVisible" width="50%">
        <el-tabs v-model="activeName">
          <el-tab-pane label="已评作品" name="first">
            <el-table :data="commentedProjectlist" stripe style="width: 100%">
              <el-table-column prop="EntriesName" label="作品名称">
              </el-table-column>
              <el-table-column prop="FinalScore" label="分数" width="180">
              </el-table-column>
              <el-table-column label="操作" width="180">
                <template slot-scope="scope">
                  <el-button type="warning" size="mini" :disabled="scope.row.Status === 1?false:true" @click="cancelReview(scope.row)">撤回评审</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="未评作品" name="second">
            <el-table :data="notProjectlist" stripe style="width: 100%">
              <el-table-column prop="EntriesName" label="作品名称">
              </el-table-column>
              <el-table-column prop="FinalScore" label="分数" width="180">
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
      <!-- 以作品维度评审详情 -->
      <el-dialog title="评审详情" :visible.sync="projectDialogVisible" width="50%">
        <el-table :data="showProjectlist" stripe style="width: 100%">
          <el-table-column prop="JudgesName" label="评委姓名">
          </el-table-column>
          <el-table-column prop="Score" label="分数" width="180"> </el-table-column>
        </el-table>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 获取列表
      queryInfo: {
        // 查询参数
        // 赛项id
        MatchID: '',
        // 赛道id
        TrackID: '',
        // 分组ID
        JudgesGroupID: '',
        // 查看方式
        QueryType: '',
        // 评委姓名
        JudgesName: '',
        // 当前页码
        pagenum: 1,
        // 每页显示条数
        pagesize: 10
      },
      // 以评委维度列表数据
      judgespagedata: [],
      // 以作品维度列表数据
      projectpagedata: [],
      total: 0,
      // 赛事名称下拉选项
      matchNameoptions: [
        {
          value: '1',
          label: '赛事1'
        },
        {
          value: '2',
          label: '赛事2'
        }
      ],
      // 赛道下拉选项
      trackNameoptions: [
        {
          value: '1',
          label: '赛道1'
        },
        {
          value: '2',
          label: '赛道2'
        }
      ],
      // 查看方式下拉选项
      viewModeOptions: [
        {
          value: '1',
          label: '以“评委”维度进行查看'
        },
        {
          value: '2',
          label: '以“作品”维度进行查看'
        }
      ],
      // 评审类型下拉选项
      reviewTypeOptions: [
        {
          value: '1',
          label: '已评审'
        },
        {
          value: '2',
          label: '未评审'
        }
      ],
      // 组名下拉选项
      groupOptions: [
        {
          value: '1',
          label: 'A组'
        },
        {
          value: '2',
          label: 'B组'
        }
      ],
      // 以评委维度评审详情 弹窗状态
      judgesDialogVisible: false,
      // 以作品维度评审详情 弹窗状态
      projectDialogVisible: false,
      // 以评委维度评审详情 tab值
      activeName: 'first',
      // 已评作品
      commentedProjectlist: [],
      // 未评作品
      notProjectlist: [],
      // 以作品维度评审详情
      showProjectlist: [],
      groupMatchID: 0
    }
  },
  created() {
    // 默认获取赛事
    this.getAllMatch()
  },
  methods: {
    //   获取评委维度列表
    async getJudgesList(newPage) {
      this.queryInfo.pagenum = newPage
      const { data: res } = await this.$http.get(
        '/api/Entries/GetEntriesReviewJudges',
        { params: this.queryInfo }
      )
      if (res.StatusCode !== 1) return console.log(res.Msg)
      console.log(res.Data)
      this.judgespagedata = res.Data.reviewProgresses
      this.total = res.Data.total
    },
    //   获取作品维度列表
    async getProjectList(newPage) {
      this.queryInfo.pagenum = newPage
      const { data: res } = await this.$http.get(
        '/api/Entries/GetEntriesReviewProject',
        { params: this.queryInfo }
      )
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.projectpagedata = res.Data.reviewProgresses
      this.total = res.Data.total
    },
    // 监听pagesize 切换显示多少条 事件
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize
      if (this.queryInfo.QueryType === '2') {
        this.getProjectList(1)
      } else {
        this.getJudgesList(1)
      }
    },
    // 监听点击了第几页 事件
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage
      if (this.queryInfo.QueryType === '2') {
        this.getProjectList(newPage)
      } else {
        this.getJudgesList(newPage)
      }
    },
    getViewMode() {
      if (this.queryInfo.QueryType === '2') {
        this.getProjectList(1)
      } else if (this.queryInfo.QueryType === '1') {
        this.getJudgesList(1)
      }
    },
    showJudges(row) {
      this.commented(row)
      this.evaluated(row)
      this.judgesDialogVisible = true
    },
    showProject(row) {
      this.reviewDetails(row)
      this.projectDialogVisible = true
    },
    // 撤回评审
    async cancelReview(row) {
      // 发起请求
      const { data: res } = await this.$http.post(
        'api/EntriesScoreRelation/SetEntriesScoreStatus',
        {
          MatchID: row.MatchID,
          TrackID: row.TrackID,
          EntriesID: row.EntriesID,
          JudgesGroupID: row.JudgesGroupID,
          JudgesID: row.JudgesID,
          Status: row.Status
        }
      )
      // 判断状态码
      if (res.StatusCode !== 1) return this.$message.error(res.Msg)
      // 成功提示
      this.$message.success(res.Msg)
      // 刷新列表
      this.commented(row)
    },
    // 已评作品
    async commented(row) {
      const { data: res } = await this.$http.get(
        '/api/Entries/GetEvaluatedItems',
        {
          params: {
            judgesId: row.JudgesID,
            status: 1
          }
        }
      )
      if (res.StatusCode !== 1) return this.$message.error('获取失败')
      this.commentedProjectlist = res.Data.entries
    },
    // 未评作品
    async evaluated(row) {
      const { data: res } = await this.$http.get(
        '/api/Entries/GetEvaluatedItems',
        {
          params: {
            judgesId: row.JudgesID,
            status: 0
          }
        }
      )
      if (res.StatusCode !== 1) return this.$message.error('获取失败')
      this.notProjectlist = res.Data.entries
    },
    // 评审详情
    async reviewDetails(row) {
      const { data: res } = await this.$http.get(
        '/api/Entries/GetReviewDetails?entriesId=' + row.EntriesID
      )
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.showProjectlist = res.Data.judges
    },
    //   下拉获取所有赛事
    async getAllMatch() {
      const { data: res } = await this.$http.get('/api/Match/GetMatchs')
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.matchNameoptions = res.Data.matchs
      // 默认选中第一项
      this.queryInfo.MatchID = this.matchNameoptions[0].MatchID
      // 加载第一项赛道信息
      this.selectGettrack(this.queryInfo.MatchID, 0)
      //   默认获取评委维度列表
      this.getJudgesList(1)
    },
    // 下拉赛项获取对应赛道
    // selectType 0搜索
    async selectGettrack(id) {
      // 存一下赛事id
      this.groupMatchID = id
      const { data: res } = await this.$http.get('/api/Track/GetTracks', {
        params: { MatchID: id + 0 }
      })
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.trackNameoptions = []
      this.queryInfo.TrackID = ''
      this.$set(this.queryInfo, 'JudgesGroupID', null)
      this.trackNameoptions = res.Data.tracks
    },
    // 下拉赛道获取对应小组
    // selectType 0搜索
    async selectGroup(id) {
      const { data: res } = await this.$http.get(
        '/api/JudgesGroup/GetJudgesGroupByMathTrackId',
        {
          params: { MatchID: this.groupMatchID, trackID: id + 0 }
        }
      )
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.groupOptions = []
      this.$set(this.queryInfo, 'JudgesGroupID', null)
      this.groupOptions = res.Data.judgesGroups
    },
    // 导出
    doDown() {
      this.$http
        .get('api/Entries/ExportReviewProgres', { params: this.queryInfo })
        .then((res) => {
          const a = document.createElement('a')
          const href = res.data.Data
          a.href = href
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        })
    }
  }
}
</script>
<style lang="less" scoped>
.el-col {
  width: 14% !important;
  margin-bottom: 10px;
}
</style>
